import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { createClearObject } from '../../../utils/utils';
import { getFilterTemplateData } from '../reducer';
import Loader from '../../../components/base/Loader/Loader';
import FilterForm from './FilterForm';
import './filterTemplate.scss';

export default function FilterModal(props) {
  const {
    onClose = () => {},
    page = '',
    getValues,
    reset,
    defaultValues,
    control,
  } = props;
  const { loadingFilterTemplateList } = useSelector(getFilterTemplateData);
  const { formatMessage } = useIntl();

  const clear = () => {
    const fields = getValues();
    const cleared = createClearObject(fields);
    reset({ ...cleared, ...defaultValues });
  };

  return (
    <div className="filter-form">
      <Loader loading={loadingFilterTemplateList} />
      <div className="filter-header">
        <div className="filter-header-text">
          {formatMessage({ id: 'filters' })}
        </div>
        <div className="filter-header-button">
          <Icons onClick={onClose} customIcon icon="close" />
        </div>
      </div>
      <div className="filter-content custom-scroll-theme">
        <FilterForm page={page} control={control} />
      </div>
      <div className="filter-footer">
        {/*      /!* <Button className="hff-clear-show" onClick={save}>{formatMessage({ id: 'show' })}</Button> *!/ */}
        <Button className="filter-button" variant="secondary" onClick={clear}>{formatMessage({ id: 'clear.all' })}</Button>
      </div>
    </div>
  );
}
